module.exports = __webpack_public_path__ + "static/sales-tax-and-compliance-report@2x-46b3a129bc8d2678e0a738da521927b3.png";